// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"d79eb943","769":"e25074b5"}[chunkId] + ".chunk.js";
};